export function fitTextPage() {
  function fitTextWidth(textElement) {
    if (!textElement) return;

    const desiredWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let containerWidth = textElement.offsetWidth;
    if (containerWidth < desiredWidth) {
      textElement.style.width = "100vw";
      containerWidth = desiredWidth;
    }

    let low = 1,
      high = 1000,
      mid;

    textElement.style.whiteSpace = "nowrap";
    textElement.style.display = "block";

    while (low <= high) {
      mid = (low + high) / 2;
      textElement.style.fontSize = `${mid}px`;

      if (textElement.scrollWidth <= containerWidth) {
        low = mid + 0.1;
      } else {
        high = mid - 0.1;
      }
    }

    textElement.style.fontSize = `${(high - 0.1).toFixed(2)}px`;
  }

  function adjustTextForAll() {
    const textElements = document.getElementsByClassName("fitText");
    for (const element of textElements) {
      fitTextWidth(element);
    }
  }

  // Trigger once DOM is ready
  document.addEventListener("DOMContentLoaded", () => {
    adjustTextForAll();
  });

  // Recalculate on window resize
  window.addEventListener("resize", adjustTextForAll);

  // Optional: Watch each fitText element for size/layout changes
  const observer = new ResizeObserver(adjustTextForAll);
  const textElements = document.getElementsByClassName("fitText");
  for (const el of textElements) {
    observer.observe(el);
  }
}
